<template>
  <div class="tile-list" ref="list">
    <div class="tile-list__inner owl-carousel" ref="carousel">
      <div
        v-for="(place, index) in places"
        :key="index"
        class="tile-list__item"
        :class="{ 'tile-list__item--odd': index % 2 }"
        :data-id="place.id"
      >
        <details-component
          :name="place.name"
          :photo="place.photo"
          :address="place.address"
          :is-video="place.isVideo"
          full
          @click="handleClick(place.id)"
          @mousemove.stop
        />
      </div>
    </div>
    <div class="tile-list__btn-wrapper" v-if="isInfinite">
      <button-component
        color="dark"
        type="half-left"
        black
        nav
        @click="handlePrevClick"
      >
        Poprzednie
      </button-component>
      <button-component
        color="dark"
        type="half-right"
        black
        nav
        @click="handleNextClick"
      >
        Następne
      </button-component>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'

import DetailsComponent from '@/containers/Map/Details'
import ButtonComponent from '@/components/Button'

export default {
  components: {
    DetailsComponent,
    ButtonComponent
  },
  props: {
    places: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      current: 0
    }
  },
  computed: {
    isInfinite () {
      return this.places.length > 9
    }
  },
  watch: {
    places () {
      this.initializeCarousel()
    }
  },
  mounted () {
    this.initializeCarousel()
  },
  methods: {
    initializeCarousel () {
      if (this.places.length) {
        this.$nextTick(() => {
          const { carousel, list } = this.$refs

          /* eslint-disable */
          this.carousel = $(carousel).owlCarousel({
            dots: false,
            responsive: {
              0: {
                items: 1,
                slideBy: 1,
                margin: 12,
                stagePadding: 40,
                loop: this.places.length > 2
              },
              576: {
                items: 2,
                slideBy: 2,
                margin: 20,
                stagePadding: 40,
                loop: this.isInfinite
              },
              890: {
                items: 3,
                slideBy: 3,
                margin: 20,
                stagePadding: 40,
                loop: this.isInfinite
              },
              1170: {
                items: 4,
                slideBy: 4,
                margin: 20,
                stagePadding: 40,
                loop: this.isInfinite
              },
              1800: {
                items: 5,
                slideBy: 5,
                margin: 30,
                stagePadding: 50,
                loop: this.isInfinite
              }
            }
          })
          $(list).on('mousewheel', list, debounce((e) => {
            if (e.deltaY > 0 || e.deltaX > 0) {
              this.carousel.trigger('next.owl')
            } else {
              this.carousel.trigger('prev.owl')
            }
              e.preventDefault()
            }, 300, { maxWait: 600, trailing: false, leading: true }))
          /* eslint-enable */
        })
      }
    },
    handleClick (id) {
      this.$emit('setActive', id)
    },
    handleNextClick () {
      this.carousel.trigger('next.owl')
    },
    handlePrevClick () {
      this.carousel.trigger('prev.owl')
    }
  }
}
</script>

<style lang="scss" scoped>
  .tile-list {
    position: fixed;
    top: 0;
    left: 0;

    width: 100vw;
    height: 100vh;

    display: flex;
    align-items: center;

    z-index: z(tiles);

    &__inner {
      align-items: center;
    }

    &__item {
      @include media-up(sm) {
        padding-top: 60px;
      }

      @include media-up(xl) {
        padding-top: 90px;
      }

      &--odd {
        padding-top: 0;
      }
    }

    &__btn-wrapper {
      @include hide-down(md);
      position: absolute;
      left: 0;
      bottom: 18px;
      width: 100%;

      @include media-up(xl) {
        bottom: 31px;
      }

      display: flex;
      justify-content: space-between;
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/Map/TileList.vue